import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LineOfBusinessComponent} from 'src/app/main/line-of-business/line-of-business.component';

const routes: Routes = [
  {
    path: '',
    component: LineOfBusinessComponent,
    title: 'Line Of Business'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LineOfBusinessRoutingModule {
}
